import { hideAndRemoveInArr } from "../../helpers";
import { toggleSingleSceneObject } from "../../togglers";

export const changeVerstakOpora = (side, isChecked = true) => {
    if (!side) {
        console.warn("[changeVerstakOpora] Сторона не определена", side);
        return;
    }
    const width = servObj.tableSize.tableWidth.current;
    const depth = servObj.tableSize.tableDepth.current;
    const { tempName } = servObj;

    const name = `verstak__${tempName}__opora__${width}x${depth}__${side}`;
    const activeTumbaArr = side === "right" ? servObj["activeVerstakTumbaRight"] : servObj["activeVerstakTumbaLeft"];
    if (isChecked) hideAndRemoveInArr(activeTumbaArr);
    toggleSingleSceneObject({
        allObjects: servObj.allVerstakOpora,
        activeArray: servObj.activeVerstakOpora,
        name,
        isChecked: isChecked,
        position: {
            y: 10,
        },
        userData: { name, side },
    });
};
